import React, { useState } from "react";
import { Logo } from "./Logo.js";
import { Menu, X, ArrowRight } from "lucide-react";

export const Navbar = ({ currentTab, onNavigate, lang, currentUser, settings }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navLinks = [
    { id: "home", labelEn: "Home", labelBn: "মূলপাতা" },
    { id: "about", labelEn: "About Us", labelBn: "আমাদের কথা" },
    { id: "curriculum", labelEn: "Curriculum", labelBn: "কারিকুলাম" },
    { id: "blog", labelEn: "Blog", labelBn: "ব্লগ ও খবর" },
    { id: "contact", labelEn: "Contact", labelBn: "যোগাযোগ" }
  ];

  return (
    <header className="sticky top-0 z-40 bg-white/95 backdrop-blur-md border-b border-emerald-950/10 shadow-xs">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <div
            onClick={() => onNavigate("home")}
            className="cursor-pointer transition-transform hover:opacity-95"
          >
            <Logo
              size="md"
              logoUrl={settings?.logo_url}
              siteName={lang === "bn" ? settings?.site_name_bn : settings?.site_name}
            />
          </div>

          <nav className="hidden md:flex items-center gap-7">
            {navLinks.map((link) => {
              const isActive = currentTab === link.id;
              return (
                <button
                  key={link.id}
                  onClick={() => onNavigate(link.id)}
                  className={`text-sm font-semibold transition-colors relative py-1 cursor-pointer ${
                    isActive ? "text-emerald-800" : "text-slate-600 hover:text-emerald-800"
                  }`}
                >
                  {lang === "bn" ? link.labelBn : link.labelEn}
                  {isActive && <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-amber-500 rounded-full" />}
                </button>
              );
            })}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <button
              onClick={() => onNavigate("contact")}
              className="px-4 py-2 text-xs font-semibold text-white bg-emerald-800 hover:bg-emerald-900 rounded-lg shadow-sm transition-all flex items-center gap-1.5 cursor-pointer"
            >
              <span>{lang === "bn" ? "ভর্তি আবেদন" : "Apply for Admission"}</span>
              <ArrowRight className="w-3.5 h-3.5" />
            </button>
          </div>

          <div className="flex md:hidden items-center gap-2">
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="px-3 py-1.5 rounded-lg border border-slate-200 text-slate-700 flex items-center gap-1 text-xs font-semibold"
            >
              {mobileMenuOpen ? <X className="w-4 h-4" /> : <Menu className="w-4 h-4" />}
              <span>{lang === "bn" ? "মেনু" : "Menu"}</span>
            </button>
          </div>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden border-t border-slate-100 bg-white px-4 pt-3 pb-6 space-y-2 shadow-lg animate-in fade-in slide-in-from-top-2 duration-150">
          {navLinks.map((link) => {
            const isActive = currentTab === link.id;
            return (
              <button
                key={link.id}
                onClick={() => {
                  onNavigate(link.id);
                  setMobileMenuOpen(false);
                }}
                className={`w-full text-left px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                  isActive ? "bg-emerald-50 text-emerald-900 font-semibold" : "text-slate-700 hover:bg-slate-50"
                }`}
              >
                {lang === "bn" ? link.labelBn : link.labelEn}
              </button>
            );
          })}
          <div className="pt-3 border-t border-slate-100 flex flex-col gap-2">
            <button
              onClick={() => {
                onNavigate("contact");
                setMobileMenuOpen(false);
              }}
              className="w-full text-center py-2.5 text-xs font-semibold text-white bg-emerald-800 rounded-lg shadow-sm"
            >
              {lang === "bn" ? "ভর্তি আবেদন ফরম" : "Apply for Admission"}
            </button>
          </div>
        </div>
      )}
    </header>
  );
};
